<template>
    <ul :class="[$style['mds-list-group'], classObject, sizeClass]" :data-mds-version="version">
        <slot></slot>
    </ul>
</template>

<script>
    // Import component's API
    import MdsListGroupProps from './list-group_props.js';

    export default {
        name: 'MdsListGroup',
        props: MdsListGroupProps,
        provide() {
            // Properties that are available for injection into components descendants https://vuejs.org/v2/api/#provide-inject
            const parentVariation = {};
            Object.defineProperty(parentVariation, 'variationObj', {
                enumerable: true,
                get: () => this.variation,
            });
            Object.defineProperty(parentVariation, 'size', {
                enumerable: true,
                get: () => this.size,
            });
            return { parentVariation };
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-list-group--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-list-group__navigation']] = this.variation === 'navigation';
                obj[this.$style['mds-list-group--with-icon']] = this.withIcon;
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './list-group.scss';
</style>
